import { CoreMenu } from 'src/@core/types';

export const leavesMenu: CoreMenu[] = [
  {
    exactMatch: true,
    id: 'my-leaves',
    title: 'My Leaves',
    type: 'item',
    url: 'hr360/leave-management/leaves',
    role: {
      roles: ['employee'],
      module: 'leaves',
      right: '',
    },
  },
  {
    exactMatch: true,
    id: 'all-leaves',
    title: 'All Leaves',
    type: 'item',
    url: 'hr360/leave-management/leaves/all',
    role: {
      roles: ['employee'],
      module: 'leaves',
      right: 'view-all',
    },
  },
  {
    id: 'leaves-approval',
    title: 'Leaves Approval',
    type: 'item',
    url: 'hr360/leave-management/approval',
    role: {
      roles: ['employee'],
      module: 'leaves-approval',
      right: '',
    },
  },
  {
    id: 'Leave-Types',
    title: 'Leave Types',
    type: 'item',
    url: 'hr360/leave-management/types',
    role: {
      roles: ['employee'],
      module: 'leave-types',
      right: '',
    },
  },
  {
    id: 'Leave-Quota',
    title: 'Leave Quota',
    type: 'item',
    url: 'hr360/leave-management/quota',
    role: {
      roles: ['employee'],
      module: 'leave-quota',
      right: '',
    },
  },
];
